import { Stack } from 'expo-router';
import React from 'react';

function Layout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default Layout;
